import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: localStorage.getItem("isAuthenticated") === "true",
  token: localStorage.getItem("token") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
  user: JSON.parse(localStorage.getItem("user") || "null"),
  permissions: JSON.parse(localStorage.getItem("permissions") || "[]"),
  loading: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, { payload }) => {
      const { token, refreshToken, user, permissions } = payload || {};
      state.isAuthenticated = true;
      state.token = token || null;
      state.refreshToken = refreshToken || null;
      state.user = user || null;
      state.permissions = permissions || [];
      localStorage.setItem("isAuthenticated", "true");
      if (token) localStorage.setItem("token", token);
      if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
      if (user) localStorage.setItem("user", JSON.stringify(user));
      if (permissions) localStorage.setItem("permissions", JSON.stringify(permissions));
    },
    updateTokens: (state, { payload }) => {
      const { token, refreshToken } = payload || {};
      state.token = token || null;
      state.refreshToken = refreshToken || null;
      if (token) localStorage.setItem("token", token);
      if (refreshToken) localStorage.setItem("refreshToken", refreshToken);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.refreshToken = null;
      state.user = null;
      state.permissions = [];
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      localStorage.removeItem("permissions");
      // Clear report card filters on logout
      localStorage.removeItem("reportCardFilters");
    },
  },
});

export const { setCredentials, updateTokens, logout } = authSlice.actions;

export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectToken = (state) => state.auth.token;
export const selectRefreshToken = (state) => state.auth.refreshToken;
export const selectUser = (state) => state.auth.user;
export const selectPermissions = (state) => state.auth.permissions;
export const selectUserRole = (state) => state.auth.user?.role;

export default authSlice.reducer;
